<template>
    <div class="mvt-suggestion grid xs-grid-cols-1 gap-3 center">
        <div class="f3 text-bold text-center">Ask a question about {{dpp.geo.address}}</div>
        <mvtCommentSuggest
            v-model="draft"
        />
        <div>
            <button
                type="button"
                class="btn primary medium"
                @click="onSubmit"
            >
               Ask
            </button>
        </div>
    </div>
</template>

<script src="./dpp-suggestion.js"></script>
